export const ADMIN = 'adm'
export const PUBLIC = 'pub'
export const IDENTIFY = 'idt'

export const ACTIVE_BASE_REST = ADMIN
